import { Controller } from '@hotwired/stimulus'
import tippy from 'tippy.js'

export class TooltipController extends Controller {
  static values = { content: String }

  declare readonly contentValue: string

  connect() {
    tippy(this.element, {
      content: this.contentValue,
      theme: 'blue',
    })
  }
}
